import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveCategoryPayload } from "../types/categoryType";

export const getCategoryList = createAsyncThunk("/category/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/category?${query.toString()}`)).data;
  return response;
});

export const saveCategory = createAsyncThunk("/category/save", async (payload: SaveCategoryPayload) => {
  const response = (await api.post("/category/action", payload)).data;
  return response;
});

export const deleteCategory = createAsyncThunk("/category/delete", async (id: number) => {
  const response = (await api.get(`/category/delete/${id}`)).data;
  return response;
});
